export default "__VITE_ASSET__EDaeDmUz__"